import { render, staticRenderFns } from "./DropdownIcon.vue?vue&type=template&id=24e12a23&"
import script from "./DropdownIcon.vue?vue&type=script&lang=js&"
export * from "./DropdownIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports